import { alertQueryErrorBody } from '../../js/alertQueryErrorBody';
import {  API_ENDPOINTS, DRAGGABLE_WINDOWS } from '../../constants.js'
import { SingletonSharedData } from '../../js/singletonSharedData';
import { Logger } from '../../js/helpers/Logger.js';

let instance = null;

export class SMResponseHelper {
    constructor() {
        if (!instance) {
            instance = this;
        }
        this.timersSMResponse = [];
        this.sharedData = new SingletonSharedData();
        this.that = null;
        return instance;
    }

    setThat(that){
        if(!this.that){
            this.that = that;
        }
    }
    clearTimer(message){
        let key = message.Subaction ;
        if(this.timersSMResponse[key]){
          Logger.Trace("SMResponseReceived CleaningTimer ",key);
          var timer = this.timersSMResponse[key];
          clearTimeout(timer);
          delete this.timersSMResponse[key];
        }
      }

      setTimer(message){        
        let messageKey =  message.Subaction;
        if(message.ExpectsReponse && !this.timersSMResponse[messageKey]){
            Logger.Trace("SMResponseExpected SetTimer ", message);
          this.timersSMResponse[messageKey] = setTimeout(()=>this.showNoResponseError(messageKey), this.sharedData.requestTimeout);
        }
      }

      showNoResponseError(key){
        delete this.timersSMResponse[key];
        Logger.Trace("SMResponseNotReceived ExecutingNotification ", key);
        this.executeNoSMResponse(key);
        this.that.props.showAlertModal(alertQueryErrorBody());  
      }

      executeNoSMResponse(key){
        switch(key){
          case API_ENDPOINTS.CALL_OUT_CAMPAIGNS:
             this.that.props.removeWindow(DRAGGABLE_WINDOWS.MANUAL_CALL);
            break;
          default: break;
        }
      }
}



// WEBPACK FOOTER //
// ./src/js/helpers/SMResponseHelper.js